import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Influencer } from '../../../../services/marketingAPI';

interface InfluencerInfoCellProps {
    record: Influencer;
}

export const InfluencerInfoCell: React.FC<InfluencerInfoCellProps> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    const avatarUrl = (record.avatar && !record.avatar.includes('default')) ? record.avatar : (mainProfile?.avatar_url || record.avatar);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar src={avatarUrl} icon={<UserOutlined />} size={40} style={{ marginRight: 12, flexShrink: 0 }} />
            <div style={{ overflow: 'hidden' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={record.name}>
                    {record.name}
                </div>
            </div>
        </div>
    );
};
